"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6263],{

/***/ 34638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ SubmitButton; },
/* harmony export */   "e": function() { return /* binding */ Wizard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82175);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faSpinner__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92332);
/* harmony import */ var _hooks_useFormAnalytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55679);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68663);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);












var Wizard = function(param) {
    var initialValues = param.initialValues, onSubmit = param.onSubmit, formPages = param.formPages, title = param.title, subtitle = param.subtitle;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), page = ref[0], setPage = ref[1];
    var activePage = formPages[page].element;
    var length = formPages.length;
    var validationSchema = formPages[page].validationSchema;
    var goNextPage = function() {
        setPage(page + 1);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "text-left text-black",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center sm:mb-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "mb-1",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-0 text-base lg:leading-none leading-tight",
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_5__/* .Formik */ .J9, {
                initialValues: initialValues,
                enableReinitialize: false,
                validationSchema: validationSchema,
                onSubmit: onSubmit,
                children: function(props) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InnerForm, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
                        activePage: activePage,
                        goNextPage: goNextPage,
                        page: page,
                        length: length
                    }));
                }
            })
        ]
    });
};
var InnerForm = function(props) {
    var values = props.values, isSubmitting = props.isSubmitting, isValid = props.isValid, page = props.page, activePage = props.activePage, goNextPage = props.goNextPage, length = props.length, setFieldValue = props.setFieldValue;
    (0,_hooks_useFormAnalytics__WEBPACK_IMPORTED_MODULE_2__/* .useFormAnalytics */ .X)(values);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_5__/* .Form */ .l0, {
        name: "scheduleServiceWizard",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_5__/* .Field */ .gN, {
                type: "hidden",
                name: "form-name",
                value: "scheduleServiceWizard"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_5__/* .Field */ .gN, {
                type: "hidden",
                name: "email"
            }),
            /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(activePage, props),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-6",
                children: page === length - 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SubmitButton, {
                    isSubmitting: isSubmitting
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                    disabled: !isValid,
                    className: "w-full py-3",
                    onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                            if (window["dataLayer"]) {
                                window["dataLayer"].push({
                                    event: "nextClicked"
                                });
                            }
                            setFieldValue("referrerSource", document.referrer, false);
                            goNextPage();
                            return [
                                2
                            ];
                        });
                    }),
                    children: "Next"
                })
            })
        ]
    });
};
var SubmitButton = function(param) {
    var isSubmitting = param.isSubmitting, buttonText = param.buttonText, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
        className: "w-full py-3",
        onClick: function(e) {
            return onClick ? onClick(e) : null;
        },
        disabled: isSubmitting,
        type: "submit",
        id: "submit-btn",
        children: isSubmitting ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
            icon: _fortawesome_free_solid_svg_icons_faSpinner__WEBPACK_IMPORTED_MODULE_10__/* .faSpinner */ .LM,
            spin: true
        }) : buttonText ? buttonText : "Get Free Quote"
    });
};


/***/ }),

/***/ 40084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ WizardInline; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82175);
/* harmony import */ var _hooks_useFormAnalytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55679);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68663);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _Wizard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34638);
/* harmony import */ var _util_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6069);
/* harmony import */ var _hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73401);
/* harmony import */ var _pages_app__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12957);
/* harmony import */ var _hooks_useTestingForms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20892);















var goToLink = function(link) {
    return window["location"].assign(link);
};
var WizardInline = function(param) {
    var initialValues = param.initialValues, onSubmit = param.onSubmit, formPages = param.formPages, isLinkForm = param.isLinkForm, linkTarget = param.linkTarget, buttonText = param.buttonText;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), page = ref[0], setPage = ref[1];
    var activePage = formPages[page].element;
    var length = formPages.length;
    var validationSchema = formPages[page].validationSchema;
    var goNextPage = function() {
        setPage(page + 1);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "text-left text-black",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_9__/* .Formik */ .J9, {
            initialValues: initialValues,
            enableReinitialize: false,
            linkTarget: linkTarget,
            isLinkForm: isLinkForm,
            buttonText: buttonText,
            validationSchema: validationSchema,
            onSubmit: onSubmit,
            children: function(props) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InnerFormInline, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, props), {
                    isLinkForm: isLinkForm,
                    buttonText: buttonText,
                    activePage: activePage,
                    linkTarget: linkTarget,
                    goNextPage: goNextPage,
                    page: page,
                    length: length
                }));
            }
        })
    });
};
var InnerFormInline = function(props) {
    var values = props.values, isSubmitting = props.isSubmitting, isValid = props.isValid, page = props.page, activePage = props.activePage, goNextPage = props.goNextPage, length = props.length, setFieldValue = props.setFieldValue, isLinkForm = props.isLinkForm, linkTarget = props.linkTarget, buttonText = props.buttonText;
    (0,_hooks_useFormAnalytics__WEBPACK_IMPORTED_MODULE_1__/* .useFormAnalytics */ .X)(values);
    var query = (0,_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_6__/* .useQueryParam */ .W)();
    var ymmValues = {
        vehicleYear: values === null || values === void 0 ? void 0 : values.vehicleYear,
        vehicleMake: values === null || values === void 0 ? void 0 : values.make,
        vehicleModel: values === null || values === void 0 ? void 0 : values.model
    };
    var variation = (0,_hooks_useTestingForms__WEBPACK_IMPORTED_MODULE_8__/* .useTestingForms */ .d)().variation;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_9__/* .Form */ .l0, {
        name: "scheduleServiceWizard",
        className: "fomo_instant",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_9__/* .Field */ .gN, {
                type: "hidden",
                name: "form-name",
                value: "scheduleServiceWizard"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_9__/* .Field */ .gN, {
                type: "hidden",
                name: "email"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "lg:flex flex-wrap block align-center justify-center content-center items-center self-center",
                children: [
                    /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement(activePage, props),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full lg:w-48 px-2 mt-2 sm:mt-0",
                        children: page === length - 1 && isLinkForm !== true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Wizard__WEBPACK_IMPORTED_MODULE_4__/* .SubmitButton */ .M, {
                            isSubmitting: isSubmitting
                        }) : // Can Be a link form or a single step form
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                            disabled: !isValid,
                            className: "w-full sm:py-2 lg:py-2 text-md sm:text-sm m-0 sm:mt-2 sm:mb-4 lg:mb-2",
                            onClick: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(e) {
                                    var linkParams;
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                                        if (isLinkForm) {
                                            e.preventDefault();
                                        }
                                        if (window["dataLayer"]) {
                                            window["dataLayer"].push({
                                                event: "nextClicked"
                                            });
                                        }
                                        setFieldValue("referrerSource", document.referrer, false);
                                        linkParams = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, query, ymmValues);
                                        if (variation) {
                                            linkParams["variation"] = variation;
                                        }
                                        isLinkForm ? goToLink((0,_util_util__WEBPACK_IMPORTED_MODULE_5__/* .serializeLinkWithParams */ .xN)("https://".concat(_pages_app__WEBPACK_IMPORTED_MODULE_7__.CUSTOMER_WEBAPP_URL, "/").concat(linkTarget), linkParams)) : goNextPage();
                                        return [
                                            2
                                        ];
                                    });
                                });
                                return function(e) {
                                    return _ref.apply(this, arguments);
                                };
                            }(),
                            children: buttonText
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 51559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HY": function() { return /* binding */ CustomInlineSelectField; },
/* harmony export */   "P6": function() { return /* binding */ CustomInlineMakeField; },
/* harmony export */   "Yl": function() { return /* binding */ CustomMakeField; },
/* harmony export */   "fw": function() { return /* binding */ CustomSelectField; },
/* harmony export */   "ln": function() { return /* binding */ CustomReferralSelectField; },
/* harmony export */   "pj": function() { return /* binding */ CustomInlineModelField; }
/* harmony export */ });
/* unused harmony export CustomReactSelectField */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82175);
/* harmony import */ var capital_case__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71292);
/* harmony import */ var react_select_creatable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41761);
/* harmony import */ var _util_form_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19090);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61275);
/* harmony import */ var _CustomTextField__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12640);













var FIELD_LABELS = {
    es: {
        vehicleYear: "A\xf1o del veh\xedculo",
        make: "Marca",
        model: "Modelo"
    }
};
var ref;
var getFieldLabel = function(fieldName, locale) {
    var ref1;
    return (ref = (ref1 = FIELD_LABELS[locale]) === null || ref1 === void 0 ? void 0 : ref1[fieldName]) !== null && ref !== void 0 ? ref : capital_case__WEBPACK_IMPORTED_MODULE_6__/* .capitalCase */ .I(fieldName);
};
var CustomSelectField = function(_param) {
    var options = _param.options, required = _param.required, errorTextStyle = _param.errorTextStyle, field = _param.field, _locale = _param.locale, locale = _locale === void 0 ? "en" : _locale, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "options",
        "required",
        "errorTextStyle",
        "field",
        "locale"
    ]);
    var label = getFieldLabel(field.name, locale);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "pb-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_CustomTextField__WEBPACK_IMPORTED_MODULE_5__/* .Label */ .__, {
                htmlFor: field.name,
                children: [
                    label,
                    required ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        style: {
                            color: "red"
                        },
                        children: " *"
                    }) : ""
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_CustomTextField__WEBPACK_IMPORTED_MODULE_5__/* .CustomFormControl */ .Jt, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, field, props), {
                as: "select",
                id: field.name,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {}),
                    options.map(function(option, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                            value: option,
                            children: option
                        }, index);
                    })
                ]
            })),
            !errorTextStyle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_10__/* .ErrorMessage */ .Bc, {
                name: field.name
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_10__/* .ErrorMessage */ .Bc, {
                name: field.name,
                children: function(msg) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: errorTextStyle,
                        children: msg
                    });
                }
            })
        ]
    });
};
var CustomReferralSelectField = function(_param) {
    var options = _param.options, required = _param.required, field = _param.field, customLabel = _param.customLabel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "options",
        "required",
        "field",
        "customLabel"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mb-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_CustomTextField__WEBPACK_IMPORTED_MODULE_5__/* .Label */ .__, {
                children: [
                    customLabel,
                    required ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        style: {
                            color: "red"
                        },
                        children: " *"
                    }) : ""
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_CustomTextField__WEBPACK_IMPORTED_MODULE_5__/* .CustomFormControl */ .Jt, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, field, props), {
                as: "select",
                id: field.name,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {}),
                    options.map(function(option, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                            value: option,
                            children: option
                        }, index);
                    })
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_10__/* .ErrorMessage */ .Bc, {
                name: field.name
            })
        ]
    });
};
var CustomReactSelectField = function(param) {
    var customLabel = param.customLabel, options = param.options, required = param.required, name = param.name;
    var ref = _sliced_to_array(useField(name), 3), field = ref[0], helper = ref[2];
    var reactSelectOptions = useMemo(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    function() {
        return pipe(sort(comparator(lt)), toReactSelectOptions)(options);
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Label, {
                htmlFor: field.name,
                children: [
                    customLabel ? customLabel : changeCase.capitalCase(field.name),
                    required ? /*#__PURE__*/ _jsx("span", {
                        style: {
                            color: "red"
                        },
                        children: " *"
                    }) : ""
                ]
            }),
            /*#__PURE__*/ _jsx(CreatableSelect, {
                id: field.name,
                options: reactSelectOptions,
                onChange: function(optionObject) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    var value = optionObject.value;
                    helper.setValue(value);
                }
            }),
            /*#__PURE__*/ _jsx(ErrorMessage, {
                render: function(errorMessage) {
                    return /*#__PURE__*/ _jsx("div", {
                        style: {
                            color: "red"
                        },
                        children: errorMessage
                    });
                },
                name: field.name
            })
        ]
    });
};
var CustomMakeField = function(_param) {
    var options = _param.options, required = _param.required, field = _param.field, _locale = _param.locale, locale = _locale === void 0 ? "en" : _locale, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "options",
        "required",
        "field",
        "locale"
    ]);
    var label = getFieldLabel(field.name, locale);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mb-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_CustomTextField__WEBPACK_IMPORTED_MODULE_5__/* .Label */ .__, {
                htmlFor: field.name,
                children: [
                    label,
                    required ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        style: {
                            color: "red"
                        },
                        children: " *"
                    }) : ""
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_CustomTextField__WEBPACK_IMPORTED_MODULE_5__/* .CustomFormControl */ .Jt, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, field, props), {
                as: "select",
                id: field.name,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {}),
                    options.map(function(option, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                            value: option,
                            children: capital_case__WEBPACK_IMPORTED_MODULE_6__/* .capitalCase */ .I(option)
                        }, index);
                    })
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_10__/* .ErrorMessage */ .Bc, {
                name: field.name
            })
        ]
    });
};
var CustomInlineSelectField = function(_param) {
    var options = _param.options, required = _param.required, field = _param.field, _locale = _param.locale, locale = _locale === void 0 ? "en" : _locale, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "options",
        "required",
        "field",
        "locale"
    ]);
    // has default option then lets pipe defaultValue
    var placeholder = getFieldLabel(field.name, locale);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "custom-chevron align-center m-2 pl-0",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_CustomTextField__WEBPACK_IMPORTED_MODULE_5__/* .CustomFormControl */ .Jt, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, field, props), {
                as: "select",
                id: field.name,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("option", {
                        value: "",
                        disabled: true,
                        children: [
                            placeholder,
                            " ",
                            required ? "*" : ""
                        ]
                    }),
                    options.map(function(option, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                            value: option,
                            children: option
                        }, index);
                    })
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_10__/* .ErrorMessage */ .Bc, {
                name: field.name
            })
        ]
    });
};
var CustomInlineModelField = function(_param) {
    var options = _param.options, required = _param.required, field = _param.field, _locale = _param.locale, locale = _locale === void 0 ? "en" : _locale, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "options",
        "required",
        "field",
        "locale"
    ]);
    var placeholder = getFieldLabel(field.name, locale);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "align-center m-2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_CustomTextField__WEBPACK_IMPORTED_MODULE_5__/* .CustomFormControl */ .Jt, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, field, props), {
                as: "select",
                id: field.name,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("option", {
                        value: "",
                        disabled: true,
                        children: [
                            placeholder,
                            " ",
                            required ? "*" : ""
                        ]
                    }),
                    options.map(function(option, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                            value: option,
                            children: option
                        }, index);
                    })
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_10__/* .ErrorMessage */ .Bc, {
                name: field.name
            })
        ]
    });
};
var CustomInlineMakeField = function(_param) {
    var options = _param.options, required = _param.required, field = _param.field, _locale = _param.locale, locale = _locale === void 0 ? "en" : _locale, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "options",
        "required",
        "field",
        "locale"
    ]);
    var placeholder = getFieldLabel(field.name, locale);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "align-center mx-2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_CustomTextField__WEBPACK_IMPORTED_MODULE_5__/* .CustomFormControl */ .Jt, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, field, props), {
                as: "select",
                id: field.name,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("option", {
                        value: "",
                        disabled: true,
                        children: [
                            placeholder,
                            " ",
                            required ? "*" : ""
                        ]
                    }),
                    options.map(function(option, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                            value: option,
                            children: capital_case__WEBPACK_IMPORTED_MODULE_6__/* .capitalCase */ .I(option)
                        }, index);
                    })
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_10__/* .ErrorMessage */ .Bc, {
                name: field.name
            })
        ]
    });
};


/***/ }),

/***/ 34818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ LeadExtraFields; },
/* harmony export */   "o": function() { return /* binding */ getExtraHiddenFieldValues; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61275);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var hiddenFieldsList = [
    {
        elementId: "extra-field-utm_source",
        name: "utm_source"
    },
    {
        elementId: "extra-field-utm_medium",
        name: "utm_medium"
    },
    {
        elementId: "extra-field-utm_campaign",
        name: "utm_campaign"
    },
    {
        elementId: "extra-field-utm_term",
        name: "utm_term"
    },
    {
        elementId: "extra-field-gclid",
        name: "gclid"
    },
    {
        elementId: "extra-field-gaid",
        name: "gaid"
    },
    {
        elementId: "extra-field-session_id",
        name: "session_id"
    },
    {
        elementId: "extra-field-campaign_name",
        name: "campaign_name"
    },
    {
        elementId: "extra-field-adgroup_name",
        name: "adgroup_name"
    },
    {
        elementId: "extra-field-match_type",
        name: "match_type"
    },
    {
        elementId: "extra-field-network",
        name: "network"
    },
    {
        elementId: "extra-field-device",
        name: "device"
    },
    {
        elementId: "extra-field-device_model",
        name: "device_model"
    },
    {
        elementId: "extra-field-keyword",
        name: "keyword"
    },
    {
        elementId: "extra-field-creative",
        name: "creative"
    }, 
];
var getExtraHiddenFieldValues = function() {
    try {
        var values = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = hiddenFieldsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var field = _step.value;
                var ref;
                var ref1;
                var hiddenFieldValue = (ref1 = (ref = document.getElementById(field.elementId)) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : null;
                values[field.name] = (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .isEmpty */ .xbD)(hiddenFieldValue) ? null : hiddenFieldValue;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .isEmpty */ .xbD)(values) ? null : values;
    } catch (e) {
        return null;
    }
};
/*
 * This component is used to add hidden fields to the lead form and to track
 * UTM params through a Google Tag Manager script.
 */ var LeadExtraFields = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "hidden absolute top-1/2 left-1/2",
        children: hiddenFieldsList.map(function(field) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                id: field.elementId
            }, field.elementId);
        })
    });
};


/***/ }),

/***/ 50809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GO": function() { return /* binding */ NoEmailPersonalInfoFormSectionInline; },
  "xG": function() { return /* binding */ PersonalInfoValidationSchema; },
  "ZP": function() { return /* binding */ ScheduleServiceMultiStep_NoEmailPersonalInfoFormSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./src/components/Fields/CustomTextField.tsx
var CustomTextField = __webpack_require__(12640);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/components/Fields/CustomSelectField.tsx
var CustomSelectField = __webpack_require__(51559);
;// CONCATENATED MODULE: ./src/data/referrals.ts
var referrals = [
    "Referred By Friend",
    "NuBrakes Van",
    "Google Maps",
    "Google Search",
    "Radio",
    "TV",
    "YouTube",
    "Yelp",
    "Facebook / Instagram",
    "Nextdoor",
    "Pandora",
    "Spotify",
    "Bing",
    "Billboard",
    "Other", 
];
var serviceUrgencyOptions = [
    "I’m looking to get my repairs done ASAP",
    "I am going to get my repairs done but not sure when",
    "I am not sure if I need repairs",
    "I am just looking for a price", 
];

;// CONCATENATED MODULE: ./src/components/Forms/ScheduleServiceMultiStep/NoEmailPersonalInfoFormSection.tsx








var NoEmailPersonalInfoFormSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-4 flex flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    name: "symptoms",
                    component: CustomTextField/* CustomTextField */.yM,
                    as: "textarea",
                    customLabel: "How can we help?",
                    subLabel: "Please list any vehicle symptoms or desired services."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    className: "my-4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    name: "fullName",
                    component: CustomTextField/* CustomTextField */.yM,
                    required: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    name: "phoneNumber",
                    component: CustomTextField/* PhoneNumberField */.g8,
                    required: true,
                    label: "Phone Number (We'll text you your quote)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    name: "zip",
                    component: CustomTextField/* CustomNumberField */.Hb,
                    placeholder: "Zip Code",
                    required: true,
                    maxLength: 5
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    name: "serviceUrgency",
                    component: CustomSelectField/* CustomReferralSelectField */.ln,
                    customLabel: "How soon do you need service?",
                    required: false,
                    options: serviceUrgencyOptions
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    name: "hearAboutUs",
                    component: CustomSelectField/* CustomReferralSelectField */.ln,
                    options: referrals,
                    customLabel: "Where did you hear about us?",
                    placeholder: "Google, Facebook, etc.",
                    required: false
                })
            ]
        })
    });
};
var NoEmailPersonalInfoFormSectionInline = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-4 flex flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                        name: "symptoms",
                        component: CustomTextField/* CustomTextField */.yM,
                        as: "textarea",
                        customLabel: "How can we help?",
                        subLabel: "Please list any vehicle symptoms or desired services."
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    className: "my-4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                        name: "fullName",
                        component: CustomTextField/* CustomTextField */.yM,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full md:w-1/2 px-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                name: "phoneNumber",
                                component: CustomTextField/* PhoneNumberField */.g8,
                                required: true,
                                label: "Phone Number"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full md:w-1/2 px-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                name: "zip",
                                component: CustomTextField/* CustomNumberField */.Hb,
                                placeholder: "Zip Code",
                                required: true,
                                maxLength: 5
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full md:w-1/2 px-2 leading-tight",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                name: "serviceUrgency",
                                component: CustomSelectField/* CustomReferralSelectField */.ln,
                                customLabel: "How soon do you need service?",
                                required: false,
                                options: serviceUrgencyOptions
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full md:w-1/2 px-2 leading-tight",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                name: "hearAboutUs",
                                component: CustomSelectField/* CustomReferralSelectField */.ln,
                                options: referrals,
                                customLabel: "Where did you hear about us?",
                                placeholder: "Google, Facebook, etc.",
                                required: false
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var PersonalInfoValidationSchema = (0,es/* object */.Ry)().shape({
    fullName: es/* string */.Z_().required("Required"),
    email: es/* string */.Z_().required("Required"),
    phoneNumber: es/* string */.Z_().required("Required").length(12, "Phone Number must be 10 characters"),
    zip: es/* string */.Z_().required("Required").length(5, "Zip code must be 5 digits."),
    serviceUrgency: es/* string */.Z_(),
    hearAboutUs: es/* string */.Z_()
});
/* harmony default export */ var ScheduleServiceMultiStep_NoEmailPersonalInfoFormSection = (NoEmailPersonalInfoFormSection);


/***/ }),

/***/ 42786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D1": function() { return /* binding */ NoEmailScheduleServiceFormMultiStep; },
  "vf": function() { return /* binding */ NoEmailScheduleServiceFormMultiStepCompact; },
  "dR": function() { return /* binding */ scheduleServiceFormMultiStepSubmit; },
  "oA": function() { return /* binding */ twDefaultInitialWizardFormValues; }
});

// UNUSED EXPORTS: mapFullNameToFirstLast

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useSource.tsx
var useSource = __webpack_require__(9326);
// EXTERNAL MODULE: ./src/components/Forms/ScheduleServiceMultiStep/WizardVariation.tsx
var WizardVariation = __webpack_require__(91416);
// EXTERNAL MODULE: ./src/components/Builder/components/WizardInline.tsx
var WizardInline = __webpack_require__(40084);
// EXTERNAL MODULE: ./src/components/Forms/ScheduleServiceMultiStep/VehicleInfoFormSection.tsx + 1 modules
var VehicleInfoFormSection = __webpack_require__(94610);
// EXTERNAL MODULE: ./src/components/Forms/ScheduleServiceMultiStep/NoEmailPersonalInfoFormSection.tsx + 1 modules
var NoEmailPersonalInfoFormSection = __webpack_require__(50809);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 14 modules
var lib = __webpack_require__(59397);
// EXTERNAL MODULE: ./node_modules/query-string/index.js + 4 modules
var query_string = __webpack_require__(54887);
// EXTERNAL MODULE: ./src/components/clients/new-backend.client.ts
var new_backend_client = __webpack_require__(36826);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js + 1 modules
var esm = __webpack_require__(40802);
;// CONCATENATED MODULE: ./src/lib/convert.ts


/*
 * For details on the _conv_v cookie structure, see:
 * https://support.convert.com/hc/en-us/articles/204495429-Convert-Experiences-Tracking-Cookies-Structure
 */ var getConvertExperimentsFromCookies = function() {
    try {
        var convertCookie = js_cookie/* default.get */.Z.get("_conv_v");
        if (!convertCookie) return null;
        var startsWith = function(str, prefix) {
            return str.indexOf(prefix) === 0;
        };
        var experimentsRaw = convertCookie.split("*").find(function(str) {
            return startsWith(str, "exp:");
        });
        if (!experimentsRaw) return null;
        var experiments = JSON.parse(experimentsRaw.replace("exp:", "").replace(/-/g, ",").replace(/\./g, ":").replace(/([a-z0-9]+):/g, '"$1":'));
        return experiments;
    } catch (e) {
        esm/* captureException */.Tb(e, {
            extra: {
                message: "Error parsing _conv_v cookie"
            },
            tags: {
                fn: "getExperimentsFromCookie"
            }
        });
        return null;
    }
};

;// CONCATENATED MODULE: ./src/components/Forms/scheduleServiceFormSubmit.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      mutation createInquiryRequest($createInquiryRequestInput: CreateInquiryRequestInput!) {\n        createInquiryRequest(createInquiryRequestInput: $createInquiryRequestInput) {\n          id\n          fullName\n          phoneNumber\n          queryParams\n          source\n          hearAboutUs\n          serviceUrgency\n          symptoms\n          zip\n          year\n          make\n          model\n          referrerSource\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var createInquiryRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
        var ref, ref1, ref2, campaignUrl, campaignQueryParams, ref3;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    campaignUrl = (ref2 = js_cookie/* default */.Z === null || js_cookie/* default */.Z === void 0 ? void 0 : js_cookie/* default.get */.Z.get("__gtm_campaign_url")) !== null && ref2 !== void 0 ? ref2 : null;
                    campaignQueryParams = campaignUrl ? (ref = query_string/* default */.Z === null || query_string/* default */.Z === void 0 ? void 0 : query_string/* default.parseUrl */.Z.parseUrl(campaignUrl)) === null || ref === void 0 ? void 0 : ref.query : null;
                    return [
                        4,
                        new_backend_client/* newBackendClient.mutate */.t.mutate({
                            variables: {
                                createInquiryRequestInput: {
                                    fullName: values.fullName,
                                    hearAboutUs: values.hearAboutUs,
                                    make: values.make,
                                    model: values.model,
                                    phoneNumber: values.phoneNumber,
                                    windowUrl: (ref3 = window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.href) !== null && ref3 !== void 0 ? ref3 : null,
                                    queryParams: query_string/* default.parse */.Z.parse(window.location.search),
                                    campaignQueryParams: campaignQueryParams,
                                    source: values.source,
                                    symptoms: values.symptoms,
                                    year: values.vehicleYear,
                                    zip: String(values.zip),
                                    serviceUrgency: values.serviceUrgency,
                                    referrerSource: values.referrerSource,
                                    convertExperimentsData: getConvertExperimentsFromCookies(),
                                    extraFields: values.extraFields
                                }
                            },
                            mutation: (0,lib/* default */.ZP)(_templateObject())
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function createInquiryRequest(values) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/util/quote-form-utils.ts + 2 modules
var quote_form_utils = __webpack_require__(53829);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/param-case/dist.es2015/index.js + 1 modules
var dist_es2015 = __webpack_require__(34539);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 240 modules
var es = __webpack_require__(61275);
// EXTERNAL MODULE: ./node_modules/capital-case/dist.es2015/index.js + 1 modules
var capital_case_dist_es2015 = __webpack_require__(71292);
// EXTERNAL MODULE: ./src/util/util.tsx
var util = __webpack_require__(6069);
// EXTERNAL MODULE: ./src/util/form-util.tsx
var form_util = __webpack_require__(19090);
// EXTERNAL MODULE: ./src/components/Fields/LeadExtraFields.tsx
var LeadExtraFields = __webpack_require__(34818);
;// CONCATENATED MODULE: ./src/components/Forms/ScheduleServiceMultiStep/NoEmailScheduleServiceFormMultiStep.tsx





















var twDefaultInitialWizardFormValues = {
    "form-name": "scheduleServiceWizard",
    fullName: "",
    email: (0,form_util/* generateFakeEmail */.W)(null),
    extraInfo: "",
    vehicleYear: "",
    phoneNumber: "",
    zip: "",
    hearAboutUs: "",
    make: "",
    model: "",
    symptoms: "",
    referredById: "",
    source: "",
    serviceUrgency: "",
    referrerSource: ""
};
var mapFullNameToFirstLast = function(fullName) {
    var nameArr = (0,es/* pipe */.zGw)(capital_case_dist_es2015/* capitalCase */.I, (0,es/* split */.Vl2)(" "))(fullName);
    var firstName = "", lastName = "";
    if (nameArr.length > 0) {
        firstName = nameArr[0];
        if (nameArr.length > 1) {
            lastName = nameArr[1];
            for(var i = 2; i < nameArr.length; i++){
                lastName = "".concat(lastName, " ").concat(nameArr[i]);
            }
        }
    }
    return {
        firstName: firstName,
        lastName: lastName
    };
};
// for source if undefined return an empty string rather than the undefined
var NoEmailScheduleServiceFormMultiStep = function(param) {
    var _initialValues = param.initialValues, initialValues = _initialValues === void 0 ? twDefaultInitialWizardFormValues : _initialValues;
    var source = (0,useSource/* useSource */.L)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WizardVariation/* WizardVariation */.q, {
        initialValues: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialValues), {
            source: source
        }),
        formPages: [
            {
                element: VehicleInfoFormSection/* default */.ZP,
                validationSchema: VehicleInfoFormSection/* twVehicleInfoValidationSchema */.fb
            }, 
        ]
    });
};
var scheduleServiceFormMultiStepSubmit = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
        var ref, ref1, ref2, ref3, firstName, extraFieldsValues, valuesWithExtraFields, results, inquiryId, make, model, vehicleYear, currUTMS;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,util/* sendGAEvent */.Nf)("ScheduleServiceForm", "submitted", values["form-name"])
                    ];
                case 1:
                    _state.sent();
                    firstName = mapFullNameToFirstLast(values.fullName).firstName;
                    extraFieldsValues = (0,LeadExtraFields/* getExtraHiddenFieldValues */.o)();
                    valuesWithExtraFields = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                        extraFields: extraFieldsValues
                    });
                    return [
                        4,
                        Promise.allSettled([
                            createInquiryRequest(valuesWithExtraFields),
                            (0,quote_form_utils/* catchAll */.km)(valuesWithExtraFields)
                        ])
                    ];
                case 2:
                    results = _state.sent();
                    inquiryId = results[0].status === "fulfilled" ? results === null || results === void 0 ? void 0 : (ref = results[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.createInquiryRequest) === null || ref3 === void 0 ? void 0 : ref3.id : undefined;
                    if (inquiryId) {
                        (0,util/* sendGAEvent */.Nf)("ScheduleServiceFormSuccess", "submitSuccess", values["form-name"]);
                    }
                    make = values.make, model = values.model, vehicleYear = values.vehicleYear;
                    currUTMS = (router_default()).query;
                    return [
                        4,
                        router_default().push({
                            pathname: "/success",
                            query: (0,_object_spread/* default */.Z)({
                                vehicleMake: (0,dist_es2015/* paramCase */.o)(make),
                                vehicleModel: (0,dist_es2015/* paramCase */.o)(model),
                                vehicleYear: vehicleYear,
                                firstName: firstName,
                                inquiry: inquiryId
                            }, currUTMS)
                        }).then(function() {
                            return window.scrollTo(0, 0);
                        })
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function scheduleServiceFormMultiStepSubmit(values) {
        return _ref.apply(this, arguments);
    };
}();
var NoEmailScheduleServiceFormMultiStepCompact = function(param) {
    var _initialValues = param.initialValues, initialValues = _initialValues === void 0 ? twDefaultInitialWizardFormValues : _initialValues, isLinkForm = param.isLinkForm, linkTarget = param.linkTarget, buttonText = param.buttonText;
    var source = (0,useSource/* useSource */.L)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WizardInline/* WizardInline */.l, {
                isLinkForm: isLinkForm,
                linkTarget: linkTarget,
                buttonText: buttonText,
                initialValues: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialValues), {
                    source: source
                }),
                onSubmit: scheduleServiceFormMultiStepSubmit,
                formPages: [
                    {
                        element: VehicleInfoFormSection/* VehicleInfoFormSectionInline */.dq,
                        validationSchema: VehicleInfoFormSection/* twVehicleInfoValidationSchema */.fb
                    },
                    {
                        element: NoEmailPersonalInfoFormSection/* NoEmailPersonalInfoFormSectionInline */.GO,
                        validationSchema: NoEmailPersonalInfoFormSection/* PersonalInfoValidationSchema */.xG
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadExtraFields/* LeadExtraFields */.V, {})
        ]
    });
};


/***/ }),

/***/ 94610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dq": function() { return /* binding */ VehicleInfoFormSectionInline; },
  "iE": function() { return /* binding */ VehicleInfoFormSectionInlineStack; },
  "ZP": function() { return /* binding */ ScheduleServiceMultiStep_VehicleInfoFormSection; },
  "fb": function() { return /* binding */ twVehicleInfoValidationSchema; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/util/quote-form-utils.ts + 2 modules
var quote_form_utils = __webpack_require__(53829);
// EXTERNAL MODULE: ./src/components/Fields/CustomSelectField.tsx
var CustomSelectField = __webpack_require__(51559);
;// CONCATENATED MODULE: ./src/hooks/useMakeModelYear.ts


var useMakeModelYear = function(setFieldValue, values) {
    var ref = (0,react.useState)([
        ""
    ]), modelOptions = ref[0], setModelOptions = ref[1];
    var ref1 = (0,react.useState)([
        ""
    ]), makeOptions = ref1[0], setMakeOptions = ref1[1];
    (0,react.useEffect)(function() {
        setFieldValue("model", "");
        // @ts-ignore
        if (values.make && values.vehicleYear) {
            setModelOptions((0,quote_form_utils/* getModelsByYearAndMake */.LR)(values.vehicleYear, values.make));
        }
    }, [
        values.make
    ]);
    (0,react.useEffect)(function() {
        setFieldValue("make", "");
        // @ts-ignore
        if (values.vehicleYear) {
            setMakeOptions((0,quote_form_utils/* getMakesByYear */.N$)(values.vehicleYear));
        }
    }, [
        values.vehicleYear
    ]);
    return {
        modelOptions: modelOptions,
        makeOptions: makeOptions
    };
};

;// CONCATENATED MODULE: ./src/components/Forms/ScheduleServiceMultiStep/VehicleInfoFormSection.tsx








var VehicleInfoFormSection = function(props) {
    var setFieldValue = props.setFieldValue, values = props.values;
    var ref = useMakeModelYear(setFieldValue, values), makeOptions = ref.makeOptions, modelOptions = ref.modelOptions;
    var locale = props === null || props === void 0 ? void 0 : props.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "text-left mb-4 w-full px-2 md:px-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    name: "vehicleYear",
                    component: CustomSelectField/* CustomSelectField */.fw,
                    options: (0,quote_form_utils/* getYears */.V4)(),
                    required: true,
                    locale: locale
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    name: "make",
                    component: CustomSelectField/* CustomMakeField */.Yl,
                    required: true,
                    options: makeOptions ? makeOptions : [],
                    disabled: !values.vehicleYear,
                    locale: locale
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    name: "model",
                    component: CustomSelectField/* CustomSelectField */.fw,
                    options: modelOptions ? modelOptions : [],
                    required: true,
                    disabled: !(values.make && values.vehicleYear),
                    locale: locale
                })
            ]
        })
    });
};
var VehicleInfoFormSectionInline = function(props) {
    var setFieldValue = props.setFieldValue, values = props.values;
    var ref = useMakeModelYear(setFieldValue, values), makeOptions = ref.makeOptions, modelOptions = ref.modelOptions;
    var locale = props === null || props === void 0 ? void 0 : props.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "block lg:flex align-center justify-center content-center items-center self-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full lg:w-48",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    name: "vehicleYear",
                    component: CustomSelectField/* CustomInlineSelectField */.HY,
                    options: (0,quote_form_utils/* getYears */.V4)(),
                    required: true,
                    locale: locale
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "inline-block w-1/2 lg:w-48",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    name: "make",
                    component: CustomSelectField/* CustomInlineMakeField */.P6,
                    required: true,
                    options: makeOptions ? makeOptions : [],
                    disabled: !values.vehicleYear,
                    locale: locale
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "inline-block w-1/2 lg:w-48",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    name: "model",
                    component: CustomSelectField/* CustomInlineModelField */.pj,
                    options: modelOptions ? modelOptions : [],
                    required: true,
                    disabled: !(values.make && values.vehicleYear),
                    locale: locale
                })
            })
        ]
    });
};
var VehicleInfoFormSectionInlineStack = function(props) {
    var setFieldValue = props.setFieldValue, values = props.values;
    var ref = useMakeModelYear(setFieldValue, values), makeOptions = ref.makeOptions, modelOptions = ref.modelOptions;
    var locale = props === null || props === void 0 ? void 0 : props.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "block",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "inline-block w-1/2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    name: "vehicleYear",
                    component: CustomSelectField/* CustomInlineSelectField */.HY,
                    options: (0,quote_form_utils/* getYears */.V4)(),
                    required: true,
                    locale: locale
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "inline-block w-1/2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    name: "make",
                    component: CustomSelectField/* CustomInlineMakeField */.P6,
                    required: true,
                    options: makeOptions ? makeOptions : [],
                    disabled: !values.vehicleYear,
                    locale: locale
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "inline-block w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                    name: "model",
                    component: CustomSelectField/* CustomInlineModelField */.pj,
                    options: modelOptions ? modelOptions : [],
                    required: true,
                    disabled: !(values.make && values.vehicleYear),
                    locale: locale
                })
            })
        ]
    });
};
var twVehicleInfoValidationSchema = (0,es/* object */.Ry)().shape({
    vehicleYear: es/* string */.Z_().required("Required"),
    make: es/* string */.Z_().required("Required"),
    model: es/* string */.Z_().required("Required")
});
/* harmony default export */ var ScheduleServiceMultiStep_VehicleInfoFormSection = (VehicleInfoFormSection);


/***/ }),

/***/ 91416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ WizardVariation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82175);
/* harmony import */ var _hooks_useFormAnalytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55679);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68663);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _pages_app__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12957);
/* harmony import */ var _hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73401);
/* harmony import */ var _hooks_useTestingForms__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20892);












var WizardVariation = function(param) {
    var initialValues = param.initialValues, formPages = param.formPages, title = param.title, subtitle = param.subtitle;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), page = ref[0];
    var activePage = formPages[page].element;
    var length = formPages.length;
    var validationSchema = formPages[page].validationSchema;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "text-left text-black",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        children: title !== null && title !== void 0 ? title : "Get A Free Quote Now"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: subtitle !== null && subtitle !== void 0 ? subtitle : "Our repair experts will send you a quote in under 5 minutes."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_7__/* .Formik */ .J9, {
                initialValues: initialValues,
                enableReinitialize: false,
                validationSchema: validationSchema,
                onSubmit: function() {
                    console.log("submitted");
                },
                children: function(props) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InnerForm, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
                        activePage: activePage,
                        page: page,
                        length: length
                    }));
                }
            })
        ]
    });
};
var InnerForm = function(props) {
    var ref, ref1, ref2;
    var values = props.values, isValid = props.isValid, activePage = props.activePage, setFieldValue = props.setFieldValue;
    var query = (0,_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_5__/* .useQueryParam */ .W)();
    var variation = (0,_hooks_useTestingForms__WEBPACK_IMPORTED_MODULE_6__/* .useTestingForms */ .d)().variation;
    var queryParams = (0,_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_5__/* .formatQueryParams */ .x)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, query), {
        variation: variation
    }));
    var symbol = queryParams === "" ? "?" : "&";
    (0,_hooks_useFormAnalytics__WEBPACK_IMPORTED_MODULE_1__/* .useFormAnalytics */ .X)(values);
    var trimmedValues = {
        vehicleYear: values === null || values === void 0 ? void 0 : (ref = values.vehicleYear) === null || ref === void 0 ? void 0 : ref.trim(),
        make: values === null || values === void 0 ? void 0 : (ref1 = values.make) === null || ref1 === void 0 ? void 0 : ref1.trim(),
        model: values === null || values === void 0 ? void 0 : (ref2 = values.model) === null || ref2 === void 0 ? void 0 : ref2.trim()
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_7__/* .Form */ .l0, {
        name: "scheduleServiceWizard",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_7__/* .Field */ .gN, {
                type: "hidden",
                name: "form-name",
                value: "scheduleServiceWizard"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_7__/* .Field */ .gN, {
                type: "hidden",
                name: "email"
            }),
            /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createElement(activePage, props),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                    disabled: !isValid,
                    className: "w-full py-3",
                    onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
                        var ref, _make, ref1;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                            setFieldValue("referrerSource", document.referrer, false);
                            if (window["dataLayer"] && window["location"]) {
                                window["dataLayer"].push({
                                    event: "nextClicked"
                                });
                                ;
                                window["location"].assign("https://".concat(_pages_app__WEBPACK_IMPORTED_MODULE_4__.CUSTOMER_WEBAPP_URL, "/get-a-quote/services").concat(queryParams).concat(symbol, "vehicleYear=").concat((ref = trimmedValues === null || trimmedValues === void 0 ? void 0 : trimmedValues.vehicleYear) !== null && ref !== void 0 ? ref : "", "&vehicleMake=").concat((_make = trimmedValues.make) !== null && _make !== void 0 ? _make : "", "&vehicleModel=").concat((ref1 = trimmedValues === null || trimmedValues === void 0 ? void 0 : trimmedValues.model) !== null && ref1 !== void 0 ? ref1 : ""));
                            }
                            return [
                                2
                            ];
                        });
                    }),
                    children: "Next"
                })
            })
        ]
    });
};


/***/ }),

/***/ 21611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ CityPhoneNumberData; }
/* harmony export */ });
var CityPhoneNumberData = {
    default: {
        phoneNumberTxt: "(855) 800-5629",
        phoneNumber: "8558005629"
    },
    generalValvoline: {
        phoneNumberTxt: "(855) 643-8773",
        phoneNumber: "8556438773"
    },
    austin: {
        phoneNumberTxt: "(512) 640-2560",
        phoneNumber: "5126402560"
    },
    "san-antonio": {
        phoneNumberTxt: "(210) 794-6444",
        phoneNumber: "2107946444"
    },
    sanantonio: {
        phoneNumberTxt: "(210) 794-6444",
        phoneNumber: "2107946444"
    },
    dallas: {
        phoneNumberTxt: "(469) 706-3497",
        phoneNumber: "4697063497"
    },
    "fort-worth": {
        phoneNumberTxt: "(469) 706-3497",
        phoneNumber: "4697063497"
    },
    houston: {
        phoneNumberTxt: "(832) 706-4115",
        phoneNumber: "8327064115"
    },
    atlanta: {
        phoneNumberTxt: "(470) 467-7736",
        phoneNumber: "4704677736"
    },
    nashville: {
        phoneNumberTxt: "(629) 206-1979",
        phoneNumber: "6292061979"
    },
    tampa: {
        phoneNumberTxt: "(813) 957-9076",
        phoneNumber: "8139579076"
    },
    jacksonville: {
        phoneNumberTxt: "(904) 867-4476",
        phoneNumber: "9048674476"
    },
    orlando: {
        phoneNumberTxt: "(689) 216-4829",
        phoneNumber: "6892164829"
    },
    miami: {
        phoneNumberTxt: "(786) 780-2495",
        phoneNumber: "7867802495"
    },
    chicago: {
        phoneNumberTxt: "(773) 242-6985",
        phoneNumber: "7732426985"
    }
};


/***/ }),

/***/ 55679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useFormAnalytics; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61275);
/* harmony import */ var _util_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6069);



var useFormAnalytics = function(newFormValues) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(newFormValues), oldFormValues = ref[0], setOldFormValues = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isInitialLoaded = ref1[0], setInitialLoaded = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), fieldsTracked = ref2[0], setFieldsTracked = ref2[1];
    //TODO we should handle this better here
    var formName = (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .propOr */ .Uth)("unknown", "form-name", newFormValues);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        try {
            if (isInitialLoaded) {
                var diffValues = (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .fromPairs */ .Pen)((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .difference */ .e50)((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .toPairs */ .Zpf)(newFormValues), (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .toPairs */ .Zpf)(oldFormValues)));
                var fieldChanged = (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .head */ .YMb)((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .keys */ .XPQ)(diffValues));
                // detect undefined field and do not send undefined
                if ((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .not */ .ffD)((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .includes */ .q9t)(fieldChanged, fieldsTracked)) && fieldChanged !== undefined) {
                    setFieldsTracked((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .concat */ .zoF)(fieldsTracked, [
                        fieldChanged
                    ]));
                    // Log to GA
                    (0,_util_util__WEBPACK_IMPORTED_MODULE_2__/* .sendGAEvent */ .Nf)("fieldChanged", String(fieldChanged), String(formName)).then((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .always */ .Bxt)(""));
                }
                setOldFormValues(newFormValues);
            } else {
                setInitialLoaded(true);
            }
        } catch (e) {
            console.error({
                e: e
            });
        }
    }, [
        oldFormValues,
        newFormValues,
        isInitialLoaded,
        fieldsTracked,
        formName
    ]);
};


/***/ }),

/***/ 9326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useSource; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _util_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6069);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61275);



var useSource = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var query = router.query;
    var pathname = router.pathname;
    var source = (0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .prop */ .vgT)("utm_source", query);
    var medium = (0,ramda__WEBPACK_IMPORTED_MODULE_2__/* .prop */ .vgT)("utm_medium", query);
    var sourceMedium = "".concat(source, " / ").concat(medium);
    var sourceFromUtm = (0,_util_util__WEBPACK_IMPORTED_MODULE_1__/* .getSourceFromUTM */ .Fj)(sourceMedium);
    return sourceFromUtm ? sourceFromUtm : (0,_util_util__WEBPACK_IMPORTED_MODULE_1__/* .getSourceFromPathname */ .BI)(pathname);
};


/***/ }),

/***/ 20892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useTestingForms; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useTestingForms = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), inFormGroup = ref[0];
    // useEffect(() => {
    //   let localValue = localStorage.getItem('inFormGroup')
    //   if (!localValue) {
    //     localValue = (Math.floor(Math.random() * 2) === 1).toString()
    //     localStorage.setItem('inFormGroup', localValue)
    //   }
    //   setInFormGroup(localValue === 'true')
    // }, [])
    return {
        inFormGroup: inFormGroup,
        variation: inFormGroup ? "email_optional" : "control"
    };
};


/***/ }),

/***/ 19090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ generateFakeEmail; }
/* harmony export */ });
/* unused harmony export toReactSelectOptions */
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61275);
/* harmony import */ var remeda__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42392);


var toReactSelectOptions = function(options) {
    return map(applySpec({
        value: identity,
        label: identity
    }))(options);
};
// generates ops{16digit random string}@email.com
var generateFakeEmail = function() {
    var phoneNumber = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    if (!phoneNumber || phoneNumber.length < 10) return "".concat((0,remeda__WEBPACK_IMPORTED_MODULE_1__/* .randomString */ .O)(16), "@email.com");
    return "".concat(phoneNumber, "@email.com");
};


/***/ })

}]);